import { callExternalApi } from './external-api.service';
import { getLogger } from '../utils/logger';

const logger = getLogger('page-view-tracking.service');

export interface PageViewTrackingResponse {
  status: string;
  message: string;
}

/**
 * Track page view event
 * @param pagePath - The path of the page being viewed (e.g., '/', '/dashboard', '/profile')
 * @param pageTitle - Optional title of the page
 * @param token - Optional JWT access token (for authenticated users)
 * @returns Promise resolving to tracking response
 */
export const trackPageView = async (
  pagePath: string,
  pageTitle?: string,
  token?: string
) => {
  try {
    logger.debug('Tracking page view event', { pagePath, pageTitle });

    const headers: Record<string, string> = {
      'content-type': 'application/json',
    };

    // Add authorization header if token is provided
    if (token) {
      headers.authorization = `Bearer ${token}`;
    }

    const config = {
      url: `${process.env.REACT_APP_API_SERVER_URL}/api/analytics/page-view`,
      method: 'POST',
      headers,
      data: {
        pagePath,
        pageTitle,
        timestamp: new Date().toISOString(),
      },
    };

    const response = await callExternalApi({ config });

    if (response.error) {
      logger.error('Failed to track page view', response.error);
      return { success: false, error: response.error };
    }

    logger.debug('Page view tracked successfully', response.data);
    return { success: true, data: response.data };

  } catch (error) {
    logger.error('Error tracking page view', error);
    return { success: false, error: { message: String(error) } };
  }
};
